<template>
  <div class="course-evaluate-win" v-if="showCourseEvaluate">
    <div class="dialog-bg">
      <div class="wrap">
        <div class="title">训练营评价</div>
        <div class="content">
          <div class="answer">
            <div class="answer-title">1.您会将此训练营推荐给其他人吗？</div>
            <!-- <div class="start-block">
              <van-rate v-model="startScore" size="16px" color="#EB1700" allow-half void-icon="star" void-color="#D2D2D2" />
              <div class="score">{{ startScore * 20 }}分</div>
            </div> -->
            <div class="start-block">
              <div
                class="block-txt"
                :class="startScore === index ? 'cur' : ''"
                v-for="(item, index) in 11"
                :key="index"
                @click="handleClickScore(index)"
              >
                {{ item - 1 }}
              </div>
            </div>
            <div class="start-txt">
              <div class="start-txt1">不推荐</div>
              <div class="start-txt1">极其推荐</div>
            </div>
          </div>
          <div class="answer">
            <div class="answer-title">2.您对此训练营内容的建议？</div>
            <van-field
              v-model="message"
              rows="4"
              type="textarea"
              maxlength="200"
              placeholder="您对训练营内容的建议"
              show-word-limit
            />
          </div>
          <div class="submit-btn" v-if="!isSubmit" @click="handleVideoFeedbacks">
            提交
          </div>
        </div>
        <div class="close" @click="hadnleClose">
          <img src="@/assets/images/course/evaluateClose.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentTraining } from '@/api/training'
import { debounce } from '@/utils/util'
import { Toast } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'CourseEvaluateWin',
  props: {
    showCourseEvaluate: {
      type: Boolean,
      default: false
    },
    videoData: {
      type: Object
    }
  },
  data() {
    return {
      startScore: -1,
      message: '',
      campId: '',
      campMainId: '',
      isSubmit: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },

  methods: {
    handleClickScore(index) {
      this.startScore = index
    },
    handleVideoFeedbacks: debounce(function() {
      if (this.startScore < 0) {
        Toast('您会将此训练营推荐给其他人吗？')
        return
      }
      if (this.radioScore < 0) {
        Toast('您期待的训练营时长为？')
        return
      }
      const params = {
        score: this.startScore,
        userId: this.userInfo.id,
        campId: this.campId,
        campMainId: this.campMainId,
        content: this.message
      }
      commentTraining(params)
        .then((res) => {
          Toast(res.data.msg)
          if (res.data.success) {
            if (this.$parent && this.$parent.handleClick) {
              this.$parent.handleClick('isCommend')
            }
            this.hadnleClose()
          }
        })
        .catch(() => {
          Toast('评价失败')
          this.hadnleClose()
        })
    }, 400),
    hadnleClose() {
      this.isSubmit = false
      this.startScore = -1
      this.message = ''
      this.$emit('update:showCourseEvaluate', false)
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.course-evaluate-win {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  background-color: rgba(0, 0, 0, 0.65);
  // padding-bottom: 100px;
  // box-sizing: border-box;

  .dialog-bg {
    position: absolute;
    // background-color: rgba(0, 0, 0, 0.65);
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    // padding-bottom: 100px;
    box-sizing: border-box;
    .wrap {
      width: 300px;
      background: #ffffff;
      border-radius: 15px;
      position: relative;
      margin: 0 auto;
      margin-top: 20%;
      // transform: translateY(-30%);
      // top: 127px;
      // left: 50%;
      // transform: translateX(-50%);

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #1f333f;
        text-align: center;
        margin-bottom: 16px;
        line-height: 1;
        line-height: 22px;
        padding-top: 20px;
        padding-bottom: 5px;
        box-sizing: border-box;
      }

      .content {
        padding-bottom: 15px;
      }

      .answer {
        padding: 0 18px;
        margin-bottom: 15px;
        box-sizing: border-box;

        .answer-title {
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          margin-bottom: 7px;
          font-weight: 400;
        }

        .start-block {
          display: flex;
          justify-content: space-between;

          .block-txt {
            width: 24px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            border-radius: 2px;
            border: 1px solid #d8d8d8;
            font-size: 13px;
            color: #2b2b2b;
            box-sizing: border-box;

            &.cur {
              border-color: #EB1700;
              background-color: rgba(254, 91, 0, 0.1);
              color: #EB1700;
            }
          }

          .score {
            color: #999;
            font-size: 14px;
            margin-left: 50px;
          }
        }

        .start-txt {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 11px;
          color: #b9b7b7;
          margin-top: 5px;
        }

        /deep/ .van-radio--horizontal {
          width: 33%;
          margin-top: 5px;
        }

        /deep/ .van-cell {
          border: 0.5px solid #cccdd0;
          border-radius: 8px;

          .van-field__body {
            height: 100px;
            overflow-y: auto;
          }
        }
      }

      .submit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
        height: 34px;
        background: #EB1700;
        opacity: 1;
        font-size: 15px;
        font-weight: 500;
        color: #fff;
        width: 210px;
        border-radius: 30px;
        margin-left: 50%;
        transform: translateX(-50%);
      }

      .close {
        position: absolute;
        bottom: -38px;
        left: 50%;
        transform: translateX(-50%);

        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}

/deep/ .van-popup--center {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/training/trainEvaluationModel.vue